module.exports = __webpack_public_path__ + "11b32f75c5bcc79e9ce4fe1dadf54724.jpg";